<div class="package-selection-modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="package-selection-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        <span *ngIf="currentStep === 'package-selection'">Select Package</span>
        <span *ngIf="currentStep === 'customer-details'">Customer Details</span>
      </h2>
      <button class="close-btn" (click)="onClose()" aria-label="Close">✕</button>
    </div>

    <!-- Content -->
    <div class="modal-content">
      <!-- Package Selection Step -->
      <div *ngIf="currentStep === 'package-selection'">
        <!-- Loading state -->
        <div *ngIf="isLoading" class="loading-state">
          <div class="loading-spinner"></div>
          <p>Loading packages...</p>
        </div>

        <!-- Packages list -->
        <div *ngIf="!isLoading && washTiers.length > 0" class="packages-list">
          <app-shared-package-card
            *ngFor="let tier of washTiers; trackBy: trackByTier"
            [title]="tier.name"
            [features]="tier.features"
            [options]="tier.options"
            [selectedOptionId]="selectedTierId === tier.id ? selectedOptionId : ''"
            (selectionChange)="onTierOptionSelected(tier.id, $event)"
          >
          </app-shared-package-card>
        </div>

        <!-- No packages state -->
        <div *ngIf="!isLoading && washTiers.length === 0" class="no-packages-state">
          <p>No packages available at the moment.</p>
        </div>
      </div>

      <!-- Customer Details Step -->
      <div *ngIf="currentStep === 'customer-details'" class="customer-details-step">
        <div class="form-section">
          <h3 class="section-title">Customer Details</h3>
          <form class="customer-form" (ngSubmit)="$event.preventDefault()">
            <div class="form-group">
              <label for="firstName">First Name *</label>
              <input
                type="text"
                id="firstName"
                [(ngModel)]="customerForm.firstName"
                name="firstName"
                placeholder="Enter first name"
                required
              />
            </div>

            <div class="form-group">
              <label for="lastName">Last Name *</label>
              <input
                type="text"
                id="lastName"
                [(ngModel)]="customerForm.lastName"
                name="lastName"
                placeholder="Enter last name"
                required
              />
            </div>

            <div class="form-group">
              <label for="phone">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                [(ngModel)]="customerForm.phone"
                name="phone"
                placeholder="Enter phone number"
                required
              />
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                [(ngModel)]="customerForm.email"
                name="email"
                placeholder="Enter email (optional)"
              />
            </div>

            <div class="form-group">
              <label for="licensePlate"
                >License Plate <span *ngIf="isLicensePlateRequired">*</span></label
              >
              <input
                type="text"
                id="licensePlate"
                [(ngModel)]="customerForm.licensePlate"
                name="licensePlate"
                [placeholder]="
                  isLicensePlateRequired ? 'Enter license plate' : 'Enter license plate (optional)'
                "
                [required]="isLicensePlateRequired"
                maxlength="20"
              />
            </div>

            <div class="form-group">
              <label for="location">Location *</label>
              <select
                id="location"
                [(ngModel)]="customerForm.location"
                name="location"
                required
                [disabled]="isLoadingLocations || locations.length === 0"
              >
                <option value="" disabled>Select a location</option>
                <option
                  *ngFor="let location of locations; trackBy: trackById"
                  [value]="location.id"
                >
                  {{ location.name }}
                </option>
              </select>
              <div *ngIf="isLoadingLocations" class="loading-text">Loading locations...</div>
              <div
                *ngIf="!isLoadingLocations && (locations.length === 0 || locationsError)"
                class="error-text"
              >
                {{ locationsError || 'No locations found.' }}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="cancel-btn" (click)="onClose()">Cancel</button>
      <div class="footer-actions">
        <button *ngIf="currentStep === 'customer-details'" class="back-btn" (click)="onBack()">
          Back
        </button>
        <button
          class="continue-btn"
          [disabled]="
            (currentStep === 'package-selection' && (!selectedOptionId || isLoading)) ||
            (currentStep === 'customer-details' &&
              (!isCustomerDetailsComplete || isLoadingLocations || isSubmitting))
          "
          (click)="onContinue()"
        >
          <span *ngIf="currentStep === 'package-selection'">Continue</span>
          <span *ngIf="currentStep === 'customer-details' && !isSubmitting">Submit</span>
          <span *ngIf="currentStep === 'customer-details' && isSubmitting">
            <span class="loading-spinner-small"></span>
            Submitting...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
